var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWellControlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "speedometer-01",
    clipPath: "url(#clip0_7864_9240)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12 1.33008V3.83008M12 1.33008C6.47715 1.33008 2 5.80723 2 11.3301M12 1.33008C17.5228 1.33008 22 5.80723 22 11.3301M12 18.8301V21.3301M12 21.3301C17.5228 21.3301 22 16.8529 22 11.3301M12 21.3301C6.47715 21.3301 2 16.8529 2 11.3301M4.5 11.3301H2M22 11.3301H19.5M19.0784 18.4085L17.3047 16.6348M4.92163 18.4085L6.69715 16.633M4.92163 4.33008L6.65808 6.06653M19.0784 4.33008L13.4999 9.83008M14 11.3301C14 12.4346 13.1046 13.3301 12 13.3301C10.8954 13.3301 10 12.4346 10 11.3301C10 10.2255 10.8954 9.33008 12 9.33008C13.1046 9.33008 14 10.2255 14 11.3301Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7864_9240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.330078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellControlIcon);
export default __webpack_public_path__ + "static/media/well-control-icon.7db583fb0a7e30997837324fef070b46.svg";
export { ForwardRef as ReactComponent };